export default __webpack_public_path__ + "fonts/Gotham-Bold.a4dfa9bf220cf2d3387c9af213c65587.svg";